// 省份列表
export const provinceListConst = [
   { label: "北京市", value: "110000" },
   { label: "天津市", value: "120000" },
   { label: "河北省", value: "130000" },
   { label: "山西省", value: "140000" },
   { label: "内蒙古自治区", value: "150000" },
   { label: "辽宁省", value: "210000" },
   { label: "吉林省", value: "220000" },
   { label: "黑龙江省", value: "230000" },
   { label: "上海市", value: "310000" },
   { label: "江苏省", value: "320000" },
   { label: "浙江省", value: "330000" },
   { label: "安徽省", value: "340000" },
   { label: "福建省", value: "350000" },
   { label: "江西省", value: "360000" },
   { label: "山东省", value: "370000" },
   { label: "河南省", value: "410000" },
   { label: "湖北省", value: "420000" },
   { label: "湖南省", value: "430000" },
   { label: "广东省", value: "440000" },
   { label: "广西壮族自治区", value: "450000" },
   { label: "海南省", value: "460000" },
   { label: "重庆市", value: "500000" },
   { label: "四川省", value: "510000" },
   { label: "贵州省", value: "520000" },
   { label: "云南省", value: "530000" },
   { label: "西藏自治区", value: "540000" },
   { label: "陕西省", value: "610000" },
   { label: "甘肃省", value: "620000" },
   { label: "青海省", value: "630000" },
   { label: "宁夏回族自治区", value: "640000" },
   { label: "新疆维吾尔自治区", value: "650000" },
   { label: "台湾省", value: "710000" },
   { label: "香港特别行政区", value: "810000" },
   { label: "澳门特别行政区", value: "820000" }
];

// 外接设备类型选项
export const externalDeviceTypesConst = [
   { label: '主控', value: '主控' },
   { label: '50米起点摄像头', value: '50米起点摄像头' },
   { label: '50米终点摄像头', value: '50米终点摄像头' },
   { label: '50*8起点摄像头', value: '50*8起点摄像头' },
   { label: '50*8中点折返摄像头', value: '50*8中点折返摄像头' },
   { label: '50*8终点折返摄像头', value: '50*8终点折返摄像头' },
   { label: '50*8终点摄像头', value: '50*8终点摄像头' },
   { label: '100米起点摄像头', value: '100米起点摄像头' },
   { label: '100米终点摄像头', value: '100米终点摄像头' },
   { label: '长跑终点摄像头', value: '长跑终点摄像头' },
   { label: '引体向上摄像头', value: '引体向上摄像头' },
   { label: '短跑起点摄像头(自定义)', value: '短跑起点摄像头(自定义)' },
   { label: '短跑终点摄像头(自定义)', value: '短跑终点摄像头(自定义)' },
   { label: '长跑终点摄像头(自定义)', value: '长跑终点摄像头(自定义)' },
   { label: '实心球起点摄像头', value: '实心球起点摄像头' },
   { label: '实心球摄像头', value: '实心球摄像头' },
   { label: '排球垫球女生摄像头', value: '排球垫球女生摄像头' },
   { label: '排球垫球男生摄像头', value: '排球垫球男生摄像头' },
   { label: '足球起点摄像头', value: '足球起点摄像头' },
   { label: '足球过程全景摄像头', value: '足球过程全景摄像头' },
   { label: '足球终点摄像头', value: '足球终点摄像头' },
   { label: '篮球过程全景摄像头', value: '篮球过程全景摄像头' },
   { label: '篮球起终点摄像头', value: '篮球起终点摄像头' },
   { label: '足篮球过程全景摄像头', value: '足篮球过程全景摄像头' },
   { label: '趣味锻炼屏摄像头', value: '趣味锻炼屏摄像头' },
   { label: '扩展位运动摄像头', value: '扩展位运动摄像头' }
];


// WEBPACK FOOTER //
// ./src/common/constant.js